import React, { useEffect, useState } from "react";
import Table, {
  AvatarCell,
  SelectColumnFilter,
  StatusPill,
} from "../../table/Table"; // new
import {getAuthorization} from "../../../axios/AxiosAut";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setAPIDetailsSupplierTable } from "../../../redux/slices/statistics/statisticSlice";

function SupplierListTableData() {
  const Navigate = useNavigate();
  const [CompanySuppliers, setCompanySuppliers] = useState([]);
  const APIDetailsSupplierTable = useSelector(
    (state) => state.statistics.APIDetailsSupplierTable
  );
  const dispatch = useDispatch();

  const getSupplierData=()=>{
    getAuthorization()
    .get("company/all_suppliers/")
    .then((res) => {
      setCompanySuppliers(res.data);
      console.log("res.data",res.data)
      dispatch(setAPIDetailsSupplierTable(res.data));

    })
    .catch((err) => {
      console.log("Error in getting customers", err);
    });
  }

  useEffect(() => {
    //Get Company suppliers
    if(APIDetailsSupplierTable.length===0){
      getSupplierData();
      console.log("inside useefeect")
      }
   
  }, []);
  const ActionHandler = (ID) => {
    Navigate("/dashboard/management/supplier-dashboard/supplier-details", {
      state: ID,
    });
  };
  const data = APIDetailsSupplierTable;
  const columns = React.useMemo(
    () => [
      {
        Header: "Name",
        accessor: "name",
      },
      {
        Header: "Country",
        accessor: "country",
      },
      {
        Header: "Postal Code",
        accessor: "post_code",
      },
      {
        Header: "Business Type",
        accessor: "business_type",
      },
      {
        Header: "Action",
        Cell: (value) => (
          <button onClick={() => ActionHandler(value.row.original.id)}>
            <svg
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15 12.1815C15 13.8391 13.654 15.1881 12 15.1881C10.346 15.1881 9 13.8391 9 12.1815C9 10.5239 10.346 9.17498 12 9.17498C13.654 9.17498 15 10.5239 15 12.1815ZM24 11.7315C24 11.7315 19.748 20.199 12.015 20.199C4.835 20.199 0 11.7315 0 11.7315C0 11.7315 4.446 4.16406 12.015 4.16406C19.709 4.16406 24 11.7315 24 11.7315ZM17 12.1815C17 9.41851 14.757 7.17061 12 7.17061C9.243 7.17061 7 9.41851 7 12.1815C7 14.9445 9.243 17.1924 12 17.1924C14.757 17.1924 17 14.9445 17 12.1815Z"
                fill="#1F78B4"
              />
            </svg>
          </button>
        ),
      },
    ],
    []
  );

  return (
    <div className="min-h-screen">
      <main className="max-w-full px-4 sm:px-6 lg:px-8 pt-4">
        <div className="mt-1">
          <Table columns={columns} data={data} text="Undefined" />
         
        </div>
      </main>
    </div>
  );
}

export default SupplierListTableData;
